import React from 'react'
import API from '../../services/api.jsx'
import Loader from '../layout/loader.jsx'
import Head from '../layout/head.jsx'
import Content from '../layout/content.jsx'
import Table from '../layout/table.jsx'

class GrapeList extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: true,
            filters: {},
            grapes: {
                columns: [
                    {
                        label: 'Grape name in English',
                        key: 'nameEn'
                    },
                    {
                        label: 'Grape name in Chinese',
                        key: 'nameZh'
                    },
                    {
                        content: 'Edit',
                        action: 'edit',
                        className: 'edit-link',
                        onClick: (id, key) => {
                            this.props.history.push('/grapes/' + id + '/edit')
                        }
                    }],
                entities: [],
                filters: [],
                actions: [{
                    classList: 'blue add',
                    label: 'New grape',
                    onClick: () => this.props.history.push('/grapes/new')
                }],
                selectedItems: [],
                multiSelect: false,
            }
        }
    }

    componentDidMount() {
        API.getGrapes(this.state.filters).then(entities => {
            entities.forEach(entity => {
                if (entity.name) {
                    if (entity.name.en) {
                        entity.nameEn = entity.name.en
                    } else {
                        entity.nameEn = '-'
                    }

                    if (entity.name.zh) {
                        entity.nameZh = entity.name.zh
                    } else {
                        entity.nameZh = '-'
                    }
                }
            })

            this.setState({
                ...this.state,
                loading: false,
                grapes: {...this.state.grapes, entities: entities}
            })
        })
    }

    loadEntities() {
        API.getGrapes(this.state.filters).then(entities => {
            entities.forEach(entity => {
                if (entity.name) {
                    if (entity.name.en) {
                        entity.nameEn = entity.name.en
                    } else {
                        entity.nameEn = '-'
                    }

                    if (entity.name.zh) {
                        entity.nameZh = entity.name.zh
                    } else {
                        entity.nameZh = '-'
                    }
                }
            })

            this.setState({
                ...this.state,
                loading: false,
                grapes: {...this.state.grapes, entities: entities}
            })
        })
    }

    render() {
        if (this.state.loading)
            return <Loader/>
        else
            return <>
                <Head title={'Grapes'}/>
                <Content>
                    <Table settings={this.state.grapes}/>
                </Content>
            </>
    }
}

export default GrapeList
